enum enumCellType {
  string = 0,
  button = 1,
  status = 2,
  icons=3
}

export { enumCellType };
